import myLogo from './AuctionSnap.png'

export const Logo = ({ ...props }) => {
  return <img src={myLogo} {...props} alt="Auction Snap Admin Logo" />
}
